module.exports = __webpack_public_path__ + "static/bmi-f35b8176b143551ed41e372733132dc6.jpg";